import BookLibraryAdapter from 'teacher-ui-client/adapters/book-library'

export default class BookLibraryReadingScaleAdapter extends BookLibraryAdapter {}
